import React from "react";

const PrivacyPolicyContent = ({ name, url, email, address }) => {
    const BrandName = () => (!url || url === "/")
        ? <b>{name}</b>
        : <a href={url} target="_blank" rel="noopener noreferrer">{name}</a>;

    return (
        <div>
            <h1>Politique de confidentialité</h1>
            <p>
                <BrandName /> croit que vos renseignements personnels méritent d&apos;être protégés et
                souscrit aux principes de confidentialité énoncés dans la Loi sur la protection des
                renseignements personnels et les documents électroniques (LPRPDE). Notre
                Politique de confidentialité décrit certaines politiques mises en œuvre au sein de{" "}
                <BrandName />,
                régissant l&apos;utilisation par {name} des renseignements personnels identifiables
                concernant les utilisateurs de notre Site et les utilisateurs des services
                disponibles par l&apos;intermédiaire de ce site (les « Services »).
            </p>
            <h2>Mises à jour de la politique de confidentialité</h2>
            <p>
                En raison de la nature rapidement évolutive d&apos;Internet, {name} peut devoir
                mettre à jour la présente Politique de confidentialité de temps à autre. Le cas
                échéant, {name}{" "}
                publiera sa Politique de confidentialité mise à jour sur notre Site situé à{" "}
                <BrandName />{" "}
                et nous pourrons envoyer un courriel aux utilisateurs inscrits, afin que vous soyez
                toujours informé des renseignements personnels identifiables que nous pouvons
                recueillir et de la façon dont nous pouvons utiliser ces renseignements. Si une
                modification vous est inacceptable, vous devez cesser d&apos;utiliser ce Site et les
                Services. Si vous ne cessez pas d&apos;utiliser ce Site et les Services, vous serez
                réputé avoir accepté la modification.
            </p>
            <p>
                Si vous avez des questions ou des plaintes concernant notre politique de
                confidentialité ou nos pratiques, vous pouvez nous joindre de l&apos;une des façons
                suivantes :
            </p>
            <ol>
                <li>Par courriel : <a href={`mailto:${email}`} target="_top">{email}</a></li>
                <li>Par courrier postal : {name}, {address}</li>
            </ol>
            <h2>Collecte et utilisation des renseignements</h2>
            <p>
                Vous pouvez généralement visiter notre site sans révéler de renseignements
                personnels identifiables à votre sujet. Cependant, dans certaines sections de ce
                site et lorsque vous utilisez nos services, nous pouvons vous inviter à nous
                contacter avec des questions ou des commentaires, demander des soumissions ou des
                renseignements, publier du contenu et d&apos;autres documents, participer à un forum
                d&apos;utilisateurs ou à un blogue, ou remplir un formulaire d&apos;inscription.
            </p>
            <p>
                En raison de la nature de certaines de ces activités, nous pouvons recueillir des
                renseignements personnels identifiables que vous soumettez, tels que votre nom,
                vos coordonnées (adresse, adresse courriel, numéro de téléphone), votre sexe, votre
                numéro d&apos;assurance sociale, votre numéro de permis de conduire, votre niveau de
                revenu et d&apos;autres renseignements financiers, des renseignements sur les permis,
                votre nom d&apos;utilisateur, votre mot de passe, votre âge ou date de naissance et
                des renseignements sur l&apos;emploi. Nous pouvons également recueillir des
                renseignements personnels identifiables supplémentaires que vous incluez
                volontairement dans vos publications ou que vous transmettez avec vos
                communications avec nous. Les autres utilisateurs pourront voir qui a publié
                certain contenu ou documents.
            </p>
            <p>
                Nous pouvons utiliser vos renseignements personnels identifiables pour fournir les
                services ou renseignements demandés, vous fournir, ou faire en sorte que nos
                partenaires de services tiers (comme décrits dans la section Divulgation
                ci-dessous) vous fournissent, des avis concernant des biens ou services que vous
                pourriez être intéressé à acheter à l&apos;avenir, vous inscrire pour utiliser notre
                site et nos services, vérifier votre autorité d&apos;accéder à notre site et améliorer
                le contenu et l&apos;administration générale du site et de nos services.
            </p>
            <h2>Retrait du consentement aux communications électroniques</h2>
            <p>
                Vous pouvez retirer votre consentement à recevoir des communications électroniques
                de notre part en tout temps en suivant les instructions de désabonnement fournies
                dans chaque communication ou en nous envoyant un courriel à{" "}
                <a href={`mailto:${email}`} target="_top">{email}.</a>
            </p>
            <h2>Confidentialité des enfants</h2>
            <p>
                <BrandName /> reconnaît les intérêts de confidentialité des enfants et nous
                encourageons les parents et tuteurs à jouer un rôle actif dans les activités et
                intérêts en ligne de leurs enfants. Ce Site n&apos;est pas destiné aux enfants de
                moins de 18 ans. <BrandName /> ne cible pas ses Services ni ce Site aux enfants
                de moins de 18 ans. {name} ne recueille pas sciemment de renseignements
                personnels identifiables auprès d&apos;enfants de moins de 18 ans.
            </p>
            <h2>Témoins (cookies)</h2>
            <p>
                Les témoins sont de petits fichiers texte stockés sur le disque dur d&apos;un
                utilisateur contenant un numéro d&apos;identification unique utilisé pour identifier
                votre ordinateur. Les témoins sont utilisés sur la plupart des sites Web et ne
                sauvegardent aucun renseignement personnel. Les navigateurs accepteront ou
                refuseront automatiquement les témoins, ou vous aviseront chaque fois qu&apos;un
                témoin est défini par un site Web que vous visitez. <BrandName /> utilise
                des témoins pour mesurer le trafic sur notre site Web et pour suivre lorsqu&apos;un
                utilisateur accède au site Web d&apos;un partenaire ou consulte une offre précise.
                Nous les utilisons pour suivre notre rendement auprès de nos partenaires afin
                d&apos;optimiser notre site Web et d&apos;améliorer l&apos;expérience utilisateur. Si vous
                souhaitez plus de renseignements, veuillez nous envoyer un courriel à{" "}
                <a href={`mailto:${email}`} target="_top">{email}</a>.
            </p>
            <h2>Renseignements agrégés</h2>
            <p>
                Le Site peut suivre le nombre total de visiteurs de notre Site, le nombre de
                visiteurs de chaque page de notre Site, le type de navigateur et les adresses IP,
                et nous pouvons analyser ces données pour des tendances et statistiques de façon
                agrégée, mais ces renseignements seront conservés, utilisés et divulgués sous forme
                agrégée seulement et ne contiendront pas de renseignements personnels
                identifiables. Nous pouvons utiliser ces renseignements agrégés pour analyser les
                tendances, administrer le Site, suivre les déplacements des utilisateurs et
                recueillir des renseignements démographiques généraux à des fins d&apos;utilisation
                agrégée.
            </p>
            <h2>Divulgation</h2>
            <p>
                Nous pouvons fournir vos renseignements personnels identifiables et les données
                générées par les témoins ainsi que les renseignements agrégés aux fournisseurs et
                agences de services que nous pouvons engager pour nous aider à vous fournir nos
                services. Nous pouvons divulguer vos renseignements personnels identifiables et
                vos communications sur ce site lorsque nous croyons raisonnablement y être tenus
                par la loi, ou lorsque nous jugeons approprié ou nécessaire de fournir ces
                renseignements aux autorités d&apos;application de la loi.
            </p>
            <p>
                Nous ne vendrons pas vos renseignements personnels identifiables à quelque
                entreprise ou organisation que ce soit, sauf que nous pouvons transférer vos
                renseignements personnels identifiables à une entité successeur lors d&apos;une
                fusion, d&apos;une consolidation ou d&apos;une autre réorganisation d&apos;entreprise à
                laquelle LowestRates.ca participe, ou à un acheteur de la totalité ou
                substantiellement la totalité des actifs de <BrandName /> auxquels
                ce site se rapporte. Lorsque vous demandez une soumission, faites une demande de
                renseignements sur des produits, services et informations sur ce site, vous
                choisissez expressément, et consentez, à ce que <BrandName /> transfère vos
                renseignements personnels identifiables à nos partenaires de services tiers et à
                ce que ces partenaires de services tiers fournissent vos renseignements
                personnels identifiables à d&apos;autres entreprises qui offrent des produits ou
                services financiers (tels que des prêts et des hypothèques) correspondant à votre
                demande. Les partenaires de services tiers peuvent vous contacter concernant
                votre demande et des produits et services financiers.
            </p>
            <h2>Liens vers des sites tiers</h2>
            <p>
                Le site peut fournir des liens vers d&apos;autres sites Web ou ressources sur
                lesquels <BrandName />{" "}
                n&apos;exerce aucun contrôle (« Sites Web externes »). Ces liens ne constituent
                pas une approbation par <BrandName />{" "}
                de ces sites Web externes. Vous reconnaissez que <BrandName /> vous fournit
                ces liens uniquement pour votre commodité, et convenez en outre que {name}
                n&apos;est pas responsable du contenu de ces Sites Web externes. Votre utilisation
                des sites Web externes est assujettie aux conditions d&apos;utilisation et aux
                politiques de confidentialité situées sur les sites liés.
            </p>
            <h2>Sécurité</h2>
            <p>
                Nous pouvons employer des mesures de sécurité procédurales et technologiques
                raisonnablement conçues pour aider à protéger vos renseignements personnels
                identifiables contre la perte, l&apos;accès non autorisé, la divulgation, la
                modification ou la destruction. {name} peut utiliser le protocole SSL et
                d&apos;autres mesures de sécurité pour aider à prévenir l&apos;accès non autorisé à vos
                renseignements personnels identifiables.
            </p>
            <p style={{fontWeight: 900}}>
                Cette Politique de confidentialité a été mise à jour pour la dernière fois le
                15 mars 2019
            </p>
        </div>
    );
};

export default PrivacyPolicyContent;
